import { JSONSchemaType } from 'ajv';

export interface Payload {
    correlationId?: string;
}

export const payloadSchema: JSONSchemaType<Payload> = {
    type: 'object',
    properties: { correlationId: { type: 'string', nullable: true } },
    required: [],
    additionalProperties: false,
};
